/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../../store/AuthContext';
import { useAppStore } from '../../../store/AppContext';
import { TarjetaService } from '../../../services';
import useAPIError from '../../../hooks/useAPIError';
import { TarjetasHelper } from '../TarjetasHelper';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import ConfirmCardType from '../Titular/form/confirmCardType';
import { HostProvider } from '../../../utils/HostProvider';
import { AddittionalPojo } from '../../../types/PersonalData';
import { CryptoUtil } from '../../../utils/CryptoUtil';
import { BackMappings } from '../../../utils/BackMappings';

interface Props {
  showModalAdicionalForm?: boolean;
  setShowModalAdicionalForm?: (visible: boolean) => void;
  additionalData?: AddittionalPojo[];
}

const TarjetaTemporalSolicitarTarjeta: FC<Props> = (Props) => {
  const {
    showModalAdicionalForm,
    setShowModalAdicionalForm,
    additionalData,
  } = Props;
  const { t } = useTranslation();
  const isCaprabo = HostProvider.isCaprabo();
  const isEroski = HostProvider.isEroski();
  const dataUser = useAuthStore();
  const dataApp = useAppStore();
  const [cardNumberShort, setCardNumberShort] = useState<string>();
  const { addError, addErrorBack } = useAPIError();
  const [load, setLoad] = useState<boolean>(true);
  const [showSolicitudAdicional, setShowSolicitudAdicional] = useState<boolean>(
    false,
  );
  const [firstCharge, setFirstCharge] = useState(true);

  const [linkTarjeta, setLinktarjeta] = useState<boolean>(true);

  const [showModal, setShowModal] = useState(false as boolean);
  const titleKey = t('tarjetas.tarjeta-socio.solicitud-title');
  const textKey = isEroski
    ? t('tarjetas.tarjeta-socio.solicitud-text')
    : t('caprabo.tarjetas.tarjeta-socio.solicitud-text-caprabo');
  const acceptButtonTextKey = t('entendido');

  const getCardNumber = () => {
    TarjetaService.getTarjeta()
      .then((response) => {
        if (response.data.error) {
          if (
            firstCharge &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addErrorBack(response.data);
        } else {
          setCardNumberShort(
            CryptoUtil.decryptAes(response.data.pojo.cardNumberShort),
          );
        }
        setFirstCharge(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };
  const doRequestNewCard = (reason: number) => {
    const isApp = dataUser.user.isApp === 'true';
    const data = {
      razonSolicitud: reason,
      isApp,
    };
    TarjetaService.requestNewCard(data)
      .then((response) => {
        if (response.data.error) {
          const notStyleOro = true;
          setLoad(false);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING', notStyleOro);
        } else {
          TarjetasHelper.uncheckAll();
          setShowModal(true);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };
  const requestNewCard = (e: any) => {
    const motivoRequest = TarjetasHelper.getRequestNewCardReason(e);
    TarjetasHelper.manageErrorLabel(motivoRequest);
    if (motivoRequest === 2) {
      setShowSolicitudAdicional(true);
    } else if (motivoRequest !== -1) {
      doRequestNewCard(motivoRequest);
    }
  };
  const requestNewCardAdicional = (e: any) => {
    const motivoRequest = 1;
    TarjetasHelper.manageErrorLabel(motivoRequest);

    doRequestNewCard(motivoRequest);
  };

  const radioChange = () => {
    TarjetasHelper.manageErrorLabel(1);
    setLinktarjeta(false);
  };
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {};

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="u-display-flex-tablet u-justify-content-flex-start">
        <div className="bloque-socio">
          <p className="title__medium u-margin-bottom-small">
            {t('tarjetas.tarjeta-socio.no-card')}
          </p>
          <p className="u-margin-bottom-medium">
            {t('tarjetas.tarjeta-socio.download')}&nbsp;
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${
                isCaprabo
                  ? process.env.REACT_APP_API_CAPRABO
                  : process.env.REACT_APP_API
              }/${dataApp.lang}/nlrVerTarjeta/html/${cardNumberShort}.html`}
              className="link link-demi"
            >
              {t('tarjetas.tarjeta-socio.temporal-card')}
            </a>
          </p>
          {/* <p className="title__medium u-margin-bottom-small"> */}
          {/*  {t('tarjetas.tarjeta-adicional.quieres-aniadir-adicional')} */}
          {/* </p> */}
          {/* <p> */}
          {/*  <a */}
          {/*    target="_blank" */}
          {/*    rel="noopener noreferrer" */}
          {/*    className="link link-demi" */}
          {/*    onClick={() => { */}
          {/*      if (setShowModalAdicionalForm) setShowModalAdicionalForm(true); */}
          {/*    }} */}
          {/*  > */}
          {/*    {t('tarjetas.tarjeta-adicional.aniadir-adicional')} */}
          {/*  </a> */}
          {/* </p> */}
        </div>

        <div className="bloque-socio">
          <form method="post">
            {(() => {
              if (!dataUser.user.adicional) {
                return (
                  <>
                    <fieldset>
                      <legend className="title__medium u-margin-bottom-small">
                        {t('tarjetas.tarjeta-socio.need-card')}
                      </legend>
                      <ul className="u-margin-bottom-medium">
                        <li className="u-margin-bottom">
                          <div className="radio radio-inline">
                            <input
                              onChange={radioChange}
                              type="radio"
                              id="perdida"
                              value={1}
                              name="necesitastarjeta"
                              className="form-control"
                            />
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label htmlFor="perdida" className="control-label">
                              {isEroski
                                ? t('tarjetas.tarjeta-socio.need-option-one')
                                : t('caprabo.tarjetas.need-option-one')}
                            </label>
                          </div>
                        </li>
                        {(() => {
                          if (isEroski) {
                            return (
                              <>
                                <li className="u-margin-bottom">
                                  <div className="radio radio-inline">
                                    <input
                                      onChange={radioChange}
                                      type="radio"
                                      id="estropeada"
                                      value={5}
                                      name="necesitastarjeta"
                                      className="form-control"
                                    />
                                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                    <label
                                      htmlFor="estropeada"
                                      className="control-label"
                                    >
                                      {t(
                                        'tarjetas.tarjeta-socio.need-option-two',
                                      )}
                                    </label>
                                  </div>
                                </li>
                                <li className="u-margin-bottom">
                                  <div className="radio radio-inline">
                                    <input
                                      onChange={radioChange}
                                      type="radio"
                                      value={2}
                                      id="familia"
                                      name="necesitastarjeta"
                                      className="form-control"
                                    />
                                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                    <label
                                      htmlFor="familia"
                                      className="control-label"
                                    >
                                      {t(
                                        'tarjetas.tarjeta-socio.need-option-three',
                                      )}
                                    </label>
                                  </div>
                                </li>
                              </>
                            );
                          }
                          return false;
                        })()}
                        {(() => {
                          if (isCaprabo && additionalData) {
                            return (
                              <>
                                <li className="u-margin-bottom">
                                  <div className="radio radio-inline">
                                    <input
                                      onChange={radioChange}
                                      type="radio"
                                      value={2}
                                      id="familia"
                                      name="necesitastarjeta"
                                      className="form-control"
                                    />
                                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                    <label
                                      htmlFor="familia"
                                      className="control-label"
                                    >
                                      {t('caprabo.tarjetas.need-option-three')}
                                    </label>
                                  </div>
                                </li>
                              </>
                            );
                          }
                          return false;
                        })()}

                        <label id="error-label" className="error hide">
                          {t('validaciones.empty-value')}
                        </label>
                      </ul>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        hidden={linkTarjeta}
                        id="solicitar-temp-btn"
                        onClick={(e) => {
                          if (isEroski) {
                            requestNewCardAdicional(e);
                          } else {
                            requestNewCard(e);
                          }
                        }}
                        className="link link-demi"
                      >
                        {t('tarjetas.tarjeta-socio.to-request')}
                      </a>
                    </fieldset>
                  </>
                );
              }
              return (
                <>
                  <fieldset>
                    <legend className="title__medium u-margin-bottom-small">
                      {t('caprabo.tarjetas.adicional-needcard')}
                    </legend>
                    <a
                      hidden={linkTarjeta}
                      id="solicitar-temp-btn"
                      onClick={(e) => {
                        requestNewCardAdicional(e);
                      }}
                      className="link link-demi"
                    >
                      {t('tarjetas.tarjeta-socio.to-request')}
                    </a>
                  </fieldset>
                </>
              );
            })()}
          </form>
        </div>
      </div>
      <ConfirmCardType
        setVisible={setShowSolicitudAdicional}
        visible={showSolicitudAdicional}
        additionalData={additionalData}
        setShowModalConfirmation={setShowModal}
      />
      <ModalConfirmacion
        isBig={false}
        isSmall
        textCentered
        showModal={showModal}
        setShowModal={setShowModal}
        title=""
        textHTMLContent={t(textKey)}
        doAceptar={emptymethod}
        doClose={emptymethod}
        showCancel={false}
        acceptButtonTextKey={acceptButtonTextKey}
        hideXButton
      />
    </>
  );
};

export default TarjetaTemporalSolicitarTarjeta;
